import {asyncRouterMap, constantRouterMap} from '@/router'

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission (roles, authorities, route) {
  if (route.meta) {
    if (!route.meta.roles && !route.meta.authorities) {
      // 不需要权限
      return true
    }
    let hasRole = route.meta.roles && roles.some(role => route.meta.roles.includes(role))
    if (hasRole) {
      return true
    }
    let hasAuthority = route.meta.authorities && authorities.some(authority => route.meta.authorities.includes(authority))
    if (hasAuthority) {
      return true
    }
    // 需要权限不满足
    return false
  }
  return true
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter (routes, roles, authorities) {
  const res = []
  routes.forEach(route => {
    const tmp = {...route}
    if (hasPermission(roles, authorities, tmp)) {
      let hasChild = tmp.children && tmp.children.length > 0
      if (hasChild) {
        tmp.children = filterAsyncRouter(tmp.children, roles, authorities)
      }
      if (!hasChild || tmp.children.length > 0) {
        res.push(tmp)
      }
    }
  })

  return res
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes ({ commit }, data) {
      return new Promise(resolve => {
        const { roles } = data
        const { authorities } = data
        let accessedRouters
        if (roles.includes('ADMIN')) {
          accessedRouters = asyncRouterMap
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, roles, authorities)
        }
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js